export default "__VITE_ASSET__DNnZuNSP__"